e360.service('titleService', [
   function() {
      var TitleService = function() {
         this.title = null;

         this.getTitle = function() {
            return this.title;
         };

         this.setTitle = function(title) {
            this.title = title;
         };
      };

      return new TitleService();
   }
]);
